module.exports = __webpack_public_path__ + "img/twilio.17a5f01c.png";